import React, { Component } from 'react'
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column'
import {Button} from 'primereact/button';
import classNames from 'classnames';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import ReactLoading from 'react-loading';
import { DeliberationService } from '../service/DeliberationService';
import { DirectionService } from '../service/DirectionService';
import { SessionService } from '../service/SessionService';
import { AffectationService } from '../service/AffectationService';
import { VilleService } from '../service/VilleService';
import { CiteService } from '../service/CiteService';

export class ListeAffecte extends Component {
    constructor(props){
        super(props);
        this.state = {
            listeAffecte : [],
            listeExcel : [],
            listeDirection : [],
            idDirection : null,
            libelleDirection : '',
            session : null,
            verifeRole : false,
            loading : false,
            globalFilter : null,
            submitted : false,
            cites: [],
            villes: [],
            selectedCite: null,
            selectedVille: null,
        }
        
        this.loadCites = this.loadCites.bind(this);
    
        this.directionService = new DirectionService();
        this.deliberationService = new DeliberationService();
        this.sessionService = new SessionService();
        this.affectationService = new AffectationService()
        this.villeService = new VilleService()
        this.citeService = new CiteService()
        
    }
    componentDidMount = () => {
        const data = localStorage.getItem('user')
        const user = JSON.parse(data)
        let role = user.roles[0]
       
        if(role === "ROLE_HEBERGEMENT_ADMIN" || role === "ROLE_HEBERGEMENT_GESTIONNAIRE_CENOU" ) {
            this.setState({verifeRole : true})
            this.directionService.getAll().then(data => {
                this.setState({listeDirection : data})
            })
            
        }
        else if(role === "ROLE_HEBERGEMENT_GESTIONNAIRE_DR"){
            this.setState({verifeRole : false, idDirection : user.idDirection})
            this.villeService.getVilleDirection(user.idDirection).then(resp => {
                let villes = Array.isArray(resp) ? resp : []
                if(villes.length>0){
                villes = villes.filter(ville => ville.nomVille !== "SAABA");
                }
                this.setState({ villes : villes });
            })
            .catch(error => {
                console.log(error)
            })
            
        }
        else if(role === "ROLE_HEBERGEMENT_ETUDIANT") {
            this.setState({verifeRole : false, idDirection : user.idDirection})
            this.sessionService.getSessionDirection(user.idDirection).then(data => {
                
                let sessionCenou = data.filter(session => {
                    if(session.statutSession === "OUVERT") return session
                })
                let sessionDr = sessionCenou[0];
                if(sessionDr.etatSession === "DELIBERATION") {
                    
                    this.setState({loading : true})
                    this.deliberationService.resultatDeliberation(sessionDr.idSessionCenou, user.idDirection).then(res => {
                        let donneeExcel = null
                        let listeAdmissible = res.data
                    
                        if(listeAdmissible){
                            listeAdmissible.sort(function(a, b){
                                if(a.moyenne > b.moyenne)
                                    return -1;
                                if(a.moyenne < b.moyenne)
                                    return 1;
                                return 0;
                            });
                            donneeExcel = listeAdmissible.map(d => ({'Ine étudiant' :  d.ine, 'Nom' : d.nomEtudiant, 'Prenom' : d.prenomEtudiant, 'sexe' : d.sexeEtudiant, 'Date naiss.' : d.dateNaissance, 'Lieu naiss.' : d.lieuNaissance, 'annee BAC' : d.anneeBac, 'Moyenne' : d.moyenne, 'ville orientation' : d.villeOrientation}))
                        }
                        
                        this.setState({
                            listeAdmissible : listeAdmissible,
                            listeExcel : donneeExcel,
                            loading : false
                        })
                    })
                    .catch(error => {
                        console.log(error);
                    })
                } 
                
            })
            .catch(error => {
                console.log(error)
            })
        }
    }

    onVilleSelected(e){
    const ville = e.value
    this.setState({selectedVille : ville})
    this.loadCites(ville.idVille)
  }
  onCiteSelected(e){
    this.setState({loading : true})
    const cite = e.value
    this.setState({selectedCite : cite})
    const idDirection = this.state.selectedVille.idDirection
    this.sessionService.getSessionDirection(idDirection).then(data => {
      const annees = data
      const maxIdAnnee = annees.reduce((max, item) =>
        item.idAnnee > max.idAnnee ? item : max
      );
      this.setState({session: maxIdAnnee})
      this.affectationService.getAssignedList(cite.idCite, maxIdAnnee.idAnnee).then(data => {
        let donneeExcel
        let listeAffecte = data
        console.log(listeAffecte)
        if(listeAffecte){
            donneeExcel = listeAffecte.map(d => ({'Ine étudiant' :  d.ine, 'Nom' : d.nomEtudiant, 'Prenom' : d.prenomEtudiant, 'Cité' : d.nomCite}))
        }
                        
        this.setState({
            listeAffecte : listeAffecte,
            listeExcel : donneeExcel,
            loading : false
        })
     })
     .catch(error => {
        console.log(error);
        this.setState({loading : false})
     })
    })
    .catch(error => {
      console.log(error.response.data)
      this.setState({loading : false})
    })
  }
  loadCites(idVille) {
    this.citeService.getCitesVille(idVille).then(data => {
        const cites = Array.isArray(data) ? data : []
        this.setState({ cites :  cites});

    })
    .catch(err => {
        console.error(err);
        this.setState({ cites: [] });
      });
    
  }


    onIdDirectionChange = (e) => {
        const val = parseInt(e.target.value)
        this.setState({idDirection : val})
        
        this.sessionService.getSessionDirection(val).then(data => {
                
            let sessionCenou = data.filter(session => {
                if(session.statutSession === "OUVERT") return session
            })
            let sessionDr = sessionCenou[0];
            
            if(sessionDr.etatSession === "DELIBERATION") {
                
                this.setState({loading : true})
                    this.deliberationService.resultatDeliberation(sessionDr.idSessionCenou, val).then(res => {
                        let donneeExcel = null
                        let listeAdmissible = res.data
                        if(listeAdmissible){
                            listeAdmissible.sort(function(a, b){
                                if(a.moyenne > b.moyenne)
                                    return -1;
                                if(a.moyenne < b.moyenne)
                                    return 1;
                                return 0;
                            });
                            donneeExcel = listeAdmissible.map(d => ({'Ine étudiant' :  d.ine, 'Nom' : d.nomEtudiant, 'Prenom' : d.prenomEtudiant, 'sexe' : d.sexeEtudiant, 'Date naiss.' : d.dateNaissance, 'Lieu naiss.' : d.lieuNaissance, 'annee BAC' : d.anneeBac, 'Moyenne' : d.moyenne, 'ville orientation' : d.villeOrientation}))
                        }
                        
                        this.setState({
                            listeAdmissible : listeAdmissible,
                            listeExcel : donneeExcel,
                            loading : false
                        })
                    })
                    .catch(error => {
                        console.log(error);
                        this.setState({loading : false})
                    })
            } 
            
        })
        .catch(error => {
            console.log(error)
        })
    }
    exportExcel = () => {
        import('xlsx').then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(this.state.listeExcel);
            const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            this.saveAsExcelFile(excelBuffer, "liste_affecte");   
        });
    }
    saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then(FileSaver => {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const data = new Blob([buffer], {
                type: EXCEL_TYPE
            });
            FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
        });
    }
    loadingSpinner = ( type, color) => (
        <ReactLoading type={type} color={color} height={200} width={50} />
    )
    render() {
        const header = (
            <div className="p-grid p-col-12" style={{marginTop : "10px"}}>
                <div className="table-header p-col-5">
                    <span className="p-input-icon-left">
                        <InputText className="p-col-6" type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Recherche globale..." />
                    </span>
                    
                </div>
            </div>
        );
        return (
            <div className="p-grid">
                
                <div className="p-col-12">
                    <div className="card card-w-title datatable-demo">
                        <div className="p-field p-grid ">
                            <div className="p-col-2"></div>
                            <div className="p-col-10 p-grid">
                                {this.state.verifeRole ?
                               
                                <div className="p-col-12 p-sm-3 p-md-3">
                                    <Dropdown optionLabel="libelleDirection" optionValue="idDirection" value={this.state.idDirection} options={this.state.listeDirection} required autoFocus className={classNames({ 'p-invalid': this.state.submitted })} placeholder="Selectionner une direction"
                                    onChange={this.onIdDirectionChange} 

                                    />
                                </div>
                              
                                :
                                ""
                                }
                            </div>
                        </div>

                        {header}
                        <div className="p-grid" style={{ marginBottom: 16 }}>
                        
                            <div className="p-col-3">
                                <label>Sélectionner la ville</label><br />
                                <Dropdown value={this.state.selectedVille} options={this.state.villes} optionLabel="nomVille"  onChange={(e) => {this.onVilleSelected(e)} } placeholder="Choisir une ville" />
                            </div>
                        
                            <div className="p-col-5">
                                <label>Sélectionner la cité</label><br />
                                <Dropdown value={this.state.selectedCite} optionLabel='nomCite' options={this.state.cites} onChange={(e) => {this.onCiteSelected(e)} } placeholder="Choisir une cité" />
                            </div>
                        </div>
                        {this.state.loading ? 
                        <div className="p-grid p-col-12">
                            <div className="p-col-6" ></div>
                            <div className="p-col-6" >
                                {this.loadingSpinner("spin","black")}
                            </div>
                        </div>
                        :
                        <>
                        <div className="p-d-flex p-ai-center export-buttons" style={{marginLeft : 10}}>
                            <Button type="button" icon="pi pi-file-excel" onClick={this.exportExcel} className="p-button-success p-mr-2" data-pr-tooltip="XLS" />
                        </div>
                        <DataTable style={{marginTop : 10}}  ref={(el) => this.dt = el} value={this.state.listeAffecte} selectionMode="single" header={"Liste des affectés ("+this.state.selectedCite?.nomCite+") : "+this.state.listeAffecte.length} paginator={true} rows={10}
                              globalFilter={this.state.globalFilter} filterMatchMode="contains" responsive={true} selection={this.state.dataTableSelection1} onSelectionChange={event => this.setState({dataTableSelection1: event.value})}>
                            <Column field="ine" header="INE" sortable={true} filter={true} filterPlaceholder="rechercher ine"/>
                            <Column field="nomEtudiant" header="Nom" sortable={true} filter={true} filterPlaceholder="rechercher nom"/>
                            <Column field="prenomEtudiant" header="Prénom" sortable={true} filter={true} filterPlaceholder="rechercher prénom"/>
                        </DataTable>
                        </>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default ListeAffecte